<!-- 敏感词拦截 -->
<template>
  <div>
    <el-row type="flex" justify="center" style="margin-top:20px;">
      <el-col :span="24">
        <el-card class="box-card">
          <div style="padding: 0px 20px 20px 10px">敏感词拦截记录</div>
          <div class="text item">
            <el-row>
              <el-form>
                <el-col :span="10">
                  <el-form-item label="选择时间" label-width="80px">
                    <el-date-picker
                        v-model="createTime"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['6:00:00', '23:59:59']"
                        :time-arrow-control="true"
                        @change="getStime">
                    </el-date-picker>
                  </el-form-item>

                </el-col>
                <el-col :span="8">
                  <el-form-item label="搜索" label-width="150px">
                    <el-input
                        placeholder="请输入敏感词"
                        v-model="serchVal">
                      <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-button style="margin-left: 20px" type="primary theme-btn" class="btn" @click.native="searchRole">
                    查询
                  </el-button>
                  <el-button type="info" class="btn" @click.native="reset">重置</el-button>
                </el-col>
              </el-form>
            </el-row>
            <!-- 表格 -->
            <el-table style="width: 100%" :data="EnterpriseeData" class="table-content">
              <el-table-column label="序号" type="index"></el-table-column>
              <el-table-column label="敏感词" show-overflow-tooltip align="center" prop="sensitiveWord"></el-table-column>
              <el-table-column label="发送人" align="center" prop="sendName"></el-table-column>
              <el-table-column label="发送单位" show-overflow-tooltip align="center" prop="receiveName"></el-table-column>
              <el-table-column label="违规来源" show-overflow-tooltip align="center" prop="source"></el-table-column>
              <el-table-column label="发送时间" align="center" prop="createTime"></el-table-column>
            </el-table>
          </div>
          <div class="pagelist" style="text-align: center">
            <el-row type="flex" justify="center">
              <el-col :span="24" class="nomore" style="margin-top:24px;">
                <el-pagination
                    v-if="pagination"
                    class="page"
                    background
                    :current-page="currentPage"
                    @current-change="current_page"
                    layout="total, prev, pager, next, jumper"
                    :total="dataNumber">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </el-card>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import Head from '@/components/header/head.vue';

export default {
  name: "company",
  components: {
    Head,
  },
  data() {
    return {
      page: 1,
      size: 10,
      EnterpriseeData: [],
      currentPage: 1,
      dataNumber: 0,
      serchVal: "", // 搜索内容
      createTime: "",
      ordertimestart: "", // 开始时间
      ordertimeend: "", // 结束时间
      pagination: true,
    }
  },
  created() {
    this.getViolations(this.page, this.size, this.serchVal)
  },
  mounted() {
  },
  methods: {
    // 获取选中的时间
    getStime(val) {
      if (val) {
        this.createTime = val;
        this.ordertimestart = this.createTime[0].toString();
        this.ordertimeend = this.createTime[1].toString();
      } else {
        this.ordertimestart = '';
        this.ordertimeend = '';
      }
    },
    // 重置搜索数据
    reset() {
      this.serchVal = ""
      this.createTime = ""
      this.currentPage = 1
      this.pagination = false
      this.$nextTick(() => {
        this.pagination = true
      })
      this.getViolations(1, this.size, "", "", "")
    },
    // 搜索
    searchRole() {
      this.getViolations(this.page, this.size, this.serchVal, this.ordertimestart, this.ordertimeend)
    },
    // 获取敏感词违规记录列表
    getViolations(page, size, serchVal, ordertimestart, ordertimeend) {
      this.axiosGet(`/sensitiveWordRecord/page/${page}/${size}`, {
        params: {
          sensitiveWord: serchVal,
          startTime: ordertimestart,
          endTime: ordertimeend
        }
      }).then((res) => {
        if (res.code == 200) {
          if (res.data.list) {
            this.EnterpriseeData = res.data.list
            this.dataNumber = res.data.total
          } else {
            this.EnterpriseeData = ""
          }

        }
      })
    },
    //分页
    current_page(currentPage) {
      this.page = currentPage
      this.getViolations(this.page, this.size, this.serchVal, this.ordertimestart, this.ordertimeend)
    },
  }
}
</script>

<style lang="less" scoped>
.newsList-box {
  width: 100%;

  .newsItemBox {
    transition: .2s;
    padding-left: 30px;
    display: flex;
    justify-content: space-between;

    .title-Top {
      line-height: 60px;
      color: black;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 220px;

    }

    .companyNature {
      line-height: 60px;
      color: black;
      width: 100px;
      text-align: center;
    }

    .BelongingContent {
      line-height: 60px;
      width: 120px;
      color: black;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .updateTime {
      line-height: 60px;
    }

    .content-bottom {
      line-height: 60px;
      margin-right: 30px;
    }
  }

  .newsItemBox:hover {
    box-shadow: 0px 3px 19px 5px rgba(42, 112, 255, 0.13);
  }
}

// 分页
.box-card {
  .box-top {
    padding: 36px 32px 0 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    .sendNewsBtn {
      width: 136px;
      height: 48px;
      border: 2px solid #1A80FC;
      border-radius: 8px;
      background: #fff;
      color: #1A80FC;
    }
  }

}


</style>
